import React from 'react'

const Footer = () => {
    return (
        <div>
            <div id = "footer" class="footer__container">
                <div class="social__icons">
                    <a href="https://www.linkedin.com/in/shi-han-lim-18887b217/?challengeId=AQGc68kKOqba2gAAAX35nNWe5sfGq9anJ6eI11QxlIz0CJAUWw33CjMor_39Mlpt-95WTAa61LXtSoRaM5nscHA1OYFTSyDz2w&submissionId=a229bc4b-097a-c416-6a6b-336cd8658f73" class="social__icon--link" target = "_blank"><i class="fab fa-linkedin"></i></a>
                    <a href="https://github.com/Lim-Shi-Han" class="social__icon--link" target = "_blank"><i class="fab fa-github"></i></a>
                    <a href="https://www.instagram.com/lim_shihan/" class="social__icon--link" target = "_blank"><i class="fab fa-instagram"></i></a>
                    <a href="https://en-gb.facebook.com/lim.han.3150" class="social__icon--link" target = "_blank"><i class="fab fa-facebook"></i></a>
                </div>
                <div class="contact">
                    <p class="email">Email: shihanlim128@gmail.com</p>
                    <p class="website__rights">&copy; Copyright 2021 Shi Han</p>
                </div>
            </div>
        </div>
    )
}

export default Footer
